module.exports = "https://www.gc-pro.gnp.com.mx/39079cbf48c10007afbb8e52e446d5cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/recuperar-contrasena/3.png
// module id = 1046
// module chunks = 0 1